import { HttpParams } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { Observable,  BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { HttpUtilsService, QueryParamsModel, QueryResultsModel } from 'app/core/_base/crud';
import { TypeOfDocument } from './fshare.model';

const API_ROOT_URL = environment.ApiRoot + '/mdocument';

@Injectable()
export class FShareService {
	lastFilter$: BehaviorSubject<QueryParamsModel> = new BehaviorSubject(new QueryParamsModel({}, 'asc', '', 0, 10));
	lastFilterDSExcel$: BehaviorSubject<any[]> = new BehaviorSubject([]);
	lastFilterInfoExcel$: BehaviorSubject<any> = new BehaviorSubject(undefined);
	lastFileUpload$: BehaviorSubject<{}> = new BehaviorSubject({});
	data_import:  BehaviorSubject<any[]> = new BehaviorSubject([]);
	ReadOnlyControl: boolean;
	constructor(private http: HttpClient,
		private httpUtils: HttpUtilsService) { }

	// LOẠI
	loadTypeOfDocument(queryParams: QueryParamsModel): Observable<QueryResultsModel>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<any>(API_ROOT_URL + '/list_type_of_document', {
			headers: httpHeaders,
			params: httpParams
		});

	}

	saveTypeOfDocument(item: any): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders(false);
		return this.http.post<any>(API_ROOT_URL+'/save_list_of_document', item, { headers: httpHeaders });
	}

	// TÀI LIỆU NỘI BỘ
	loadDocuments(queryParams: QueryParamsModel): Observable<QueryResultsModel>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<any>(API_ROOT_URL + '/list_document', {
			headers: httpHeaders,
			params: httpParams
		});

	}

	saveDocument(item: any): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders(false);
		return this.http.post<any>(API_ROOT_URL+'/save_document', item, { headers: httpHeaders });
	}

	getDetailDocument(id: number): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders(false);
		const httpParams = new HttpParams().set('_id', id.toString())
		return this.http.get<any>(API_ROOT_URL + '/detail_document', {
			headers: httpHeaders,
			params: httpParams
		});
	}

	downloadFile(_id: number): Observable<Blob>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const params = new HttpParams().set('_id', _id.toString());
		return this.http.get<Blob>(API_ROOT_URL + '/download_file', {
		  headers: httpHeaders,
		  params: params,
		  responseType: 'blob' as 'json'
		});
	}

	removeFile(_id: number){
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = new HttpParams().set('_id', _id.toString());
		return this.http.get<any>(API_ROOT_URL + '/delete_file',{
			headers: httpHeaders,
			params: httpParams
		});
	}

	checkCodeDocument(code: string): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders(false);
		const httpParams = new HttpParams().set('code', code.toString())
		return this.http.get<any>(API_ROOT_URL + '/check_code_document', {
			headers: httpHeaders,
			params: httpParams
		});
	}

}
